import { render, staticRenderFns } from "./IconDeviceTabletOutline.vue?vue&type=template&id=3bd99275"
import script from "./IconDeviceTabletOutline.vue?vue&type=script&lang=js"
export * from "./IconDeviceTabletOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports